module.exports = __webpack_public_path__ + "img/32.54a801d9.jpg";